import { render, staticRenderFns } from "./userHero.vue?vue&type=template&id=36d7409b&"
import script from "./userHero.vue?vue&type=script&lang=js&"
export * from "./userHero.vue?vue&type=script&lang=js&"
import style0 from "./userHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports